import {
  configureStore,
  EnhancedStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { rootReducer } from "./RootReducer";

function getStore(): EnhancedStore {
    return configureStore({
        devTools: true,
        reducer: rootReducer,
        middleware: getDefaultMiddleware({})
    })
}

export const store = getStore()